export const MAX_BUNDLE_PRODUCTS = 15;
